const RANGES = ['today', 'yesterday', '7d', '30d', 'custom'] as const;
export type Range = (typeof RANGES)[number];

export function RangePicker({
  value,
  onChange,
  ranges = RANGES,
}: {
  value: Range;
  onChange: (r: Range) => void;
  ranges?: readonly Range[];
}) {
  return (
    <div className="flex flex-wrap justify-start sm:justify-end bg-bg-secondary border border-border-subtle rounded-sm p-1">
      {ranges.map((r) => (
        <button
          key={r}
          onClick={() => onChange(r)}
          className={`px-3 py-1.5 text-xs font-display uppercase tracking-wider rounded-sm transition-all ${
            value === r
              ? 'bg-neon-cyan/10 text-neon-cyan border border-neon-cyan/30'
              : 'text-text-secondary hover:text-text-primary'
          }`}
        >
          {r}
        </button>
      ))}
    </div>
  );
}
